import React from 'react';
import { useToast } from '../contexts/ToastContext';

const TYPE_STYLES = {
  success: 'bg-green-600',
  error: 'bg-red-600',
  info: 'bg-grafokett-blue',
};

const TYPE_ICONS = {
  success: 'fas fa-check-circle',
  error: 'fas fa-exclamation-triangle',
  info: 'fas fa-info-circle',
};

const Toast = () => {
  const { toasts, dismissToast } = useToast();

  if (!toasts.length) return null;

  return (
    <div
      data-testid="toast-container"
      className="fixed bottom-4 right-4 z-50 flex flex-col space-y-2"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          className={`flex items-center text-white rounded-lg px-4 py-3 shadow-lg max-w-sm ${
            TYPE_STYLES[toast.type] || TYPE_STYLES.info
          }`}
        >
          <i className={`${TYPE_ICONS[toast.type] || TYPE_ICONS.info} mr-3`}></i>
          <span className="text-sm flex-1">{toast.message}</span>
          <button
            type="button"
            aria-label="Dismiss notification"
            onClick={() => dismissToast(toast.id)}
            className="ml-4 text-white text-opacity-80 hover:text-opacity-100"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toast;
